import './inbox_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.AppleStore ||= {}

class Monitoring.Views.SocialContents.AppleStore.ReviewCommentView extends Monitoring.Views.SocialContents.InboxContentView

  render: ->
    super
    reviewStarsView = new Monitoring.Views.ReviewStarsView()
    @$el.find('#comment-review-stars').html(reviewStarsView.render().el)
    reviewStarsView.setRating(@_starRating()) if @_starRating()
    this

  _starRating: ->
    if (@model.subType() == 'apple_app_store_review_comment')
      if(this.model.get('data').appStoreData.user_id == "Developer")
        this.model.get('data').appStoreData.parent.rating
      else
        this.model.get('data').appStoreData.rating

  getHeaderView: (options) ->
    new Monitoring.Views.SocialContents.SocialContentReviewCommentHeaderView(options)
